import { Ref } from 'vue';
import {
  L1Validations,
  HekateDisplayField,
  HekateDisplayForm,
  Trans,
  Translations,
} from 'www-shared';
import ExternalUtil from '../../../ExternalUtil';

export default class FormFacetCoordinator {
  private readonly formDefinition: Ref<HekateDisplayForm>;

  private readonly formElement: Ref<null | HTMLFormElement>;

  private readonly isShowThankYou: Ref<boolean>;

  private readonly isFormSubmitting: Ref<boolean>;

  private readonly supportEmailText: Ref<string>;

  private readonly successMessageHtml: Ref<string>;

  private readonly isShowSuccessMessage: Ref<boolean>;

  private readonly isShow409Error: Ref<boolean>;

  private readonly isShowForm: Ref<boolean>;

  private readonly onSubmitForm: (evt: Event) => void;

  constructor({
    formDefinition,
    formElement,
    supportEmailText,
    isFormSubmitting,
    isShowThankYou,
    onSubmitForm,
    isShowSuccessMessage,
    successMessageHtml,
    isShow409Error,
    isShowForm,
  }: {
    formDefinition: Ref<HekateDisplayForm>,
    formElement: Ref<null | HTMLFormElement>;
    supportEmailText: Ref<string>,
    isFormSubmitting: Ref<boolean>,
    isShowThankYou: Ref<boolean>,
    onSubmitForm: (evt: Event) => void,
    isShowSuccessMessage: Ref<boolean>,
    successMessageHtml: Ref<string>,
    isShow409Error: Ref<boolean>,
    isShowForm: Ref <boolean>,
  }) {
    this.onSubmitForm = onSubmitForm;
    this.formDefinition = formDefinition;
    this.formElement = formElement;
    this.isShowThankYou = isShowThankYou;
    this.isFormSubmitting = isFormSubmitting;
    this.supportEmailText = supportEmailText;
    this.successMessageHtml = successMessageHtml;
    this.isShowSuccessMessage = isShowSuccessMessage;
    this.isShow409Error = isShow409Error;
    this.isShowForm = isShowForm;
  }

  /** Validate the field on blur */
  private static onFieldBlur(field: HekateDisplayField) {
    const persistErrors = field.errorMessages.filter((err) => err.isPersisted);
    L1Validations.blurSingleField({ field }).then((fieldError) => {
      field.errorMessages.splice(0, field.errorMessages.length);
      field.isValidated = false;
      if (fieldError) {
        field.errorMessages.push({
          message: fieldError.message,
          hint: fieldError.hint,
        });
        return;
      }
      if (persistErrors.length) {
        field.errorMessages.push(...persistErrors);
        return;
      }
      field.isValidated = field.val !== '';
    });
  }

  /** Clear/Reset validation on focus */
  private static onFieldFocus(field: HekateDisplayField) {
    field.isValidated = false;
  }

  private clear409Error() {
    this.isShow409Error.value = false;
    ExternalUtil.safeResetRecaptcha();
  }

  public setup() {
    if (window.wwwHekateTranslations) {
      Trans.populateTranslations({
        language: ExternalUtil.getSiteLang(),
        translations: window.wwwHekateTranslations,
      });
    } else {
      // TODO remove this, the above should always be true
      Trans.populateTranslations({
        language: ExternalUtil.getSiteLang(),
        translations: Translations,
      });
    }

    return {
      formElement: this.formElement,
      formDefinition: this.formDefinition,
      isShowThankYou: this.isShowThankYou,
      isFormSubmitting: this.isFormSubmitting,
      supportEmailText: this.supportEmailText,
      successMessageHtml: this.successMessageHtml,
      isShowSuccessMessage: this.isShowSuccessMessage,
      isShow409Error: this.isShow409Error,
      isShowForm: this.isShowForm,
      onFieldBlur: FormFacetCoordinator.onFieldBlur.bind(this),
      onFieldFocus: FormFacetCoordinator.onFieldFocus,
      onSubmitForm: this.onSubmitForm,
      clear409Error: this.clear409Error.bind(this),
    };
  }
}
